import { useEffect, useMemo } from 'react';
import { useAuth } from '../../../utils/Auth';
import { saveDescriptionData } from '../../../utils/QRFunctions/qrActions';
import { migrateDescriptionIfNeeded } from '../../../utils/QRFunctions/migrateDescription';
import styles from './Description.module.css';

export default function Description(props) {
    const { reference } = props;
    const { qr_data, dataDispatch } = useAuth();

    useEffect(() => {
        const handleMigrateDescription = async() => {
            const {updated = false, data = ""} = await migrateDescriptionIfNeeded(qr_data, dataDispatch);
            if (updated === true && data) {
                dataDispatch({ type: 'description', data });
            }
        };

        handleMigrateDescription();
    }, [qr_data?.data?.qr_type, qr_data?.id, dataDispatch]);

    const handleDescription = (e) => {
        const newDescription = e.target.value;
        dataDispatch({ type: 'description', data: newDescription });

        if (reference !== 'new' && (qr_data?.id.includes('-') && qr_data?.data.created_at)) {
            saveDescriptionData(qr_data?.id, newDescription, qr_data.data);
        }
    };

    const filled = useMemo(() => {
        if (qr_data?.data?.description) {
            return true;
        } else {
            return false;
        }
    },[qr_data?.data?.description]);

    return (
        <div className={styles.inputGroup}>
            <div className={styles.fade} />
            <textarea id='textarea-label' className={styles.textArea} value={qr_data?.data?.description || ''} onChange={handleDescription} ></textarea>
            <label htmlFor='textarea-label' className={filled ? styles.labelFilled : styles.label} style={{marginRight:'0.5rem'}}>Description</label>
        </div>
    );
};
